
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.611 1.412H7.82c-.66 0-1.194.535-1.194 1.194v13.792c0 .66.534 1.195 1.194 1.195h13.792c.66 0 1.195-.535 1.195-1.195V2.606c0-.66-.535-1.194-1.195-1.194zM7.82 0a2.606 2.606 0 00-2.606 2.606v13.792a2.606 2.606 0 002.606 2.607h13.792a2.606 2.606 0 002.606-2.607V2.606A2.606 2.606 0 0021.611 0H7.82z"}}),_c('path',{attrs:{"d":"M0 7.602a2.606 2.606 0 012.606-2.606h13.792a2.606 2.606 0 012.607 2.606v13.792a2.606 2.606 0 01-2.607 2.607H2.606A2.606 2.606 0 010 21.394V7.602z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M12.983 11.986c.278.273.282.72.009.998L8.938 17.11a.706.706 0 01-1.007 0l-2.027-2.063a.706.706 0 111.007-.99l1.523 1.552 3.551-3.615a.706.706 0 01.998-.008z","fill":"#fff"}})])
          )
        }
      }
    